module.exports = __webpack_public_path__ + "static/media/A4-Confirm-Wired-Chime.a87f32f1.png";